/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_Discomfort_LeadInputs */

const en_us2_swap_discomfort_lead = /** @type {(inputs: Swap_Discomfort_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lighter options first. If it's pain, log it under Pain and limitations.`)
};

const pt_br2_swap_discomfort_lead = /** @type {(inputs: Swap_Discomfort_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opções mais leves primeiro. Se for dor, registre em Dores e limitações.`)
};

const es_419_swap_discomfort_lead = /** @type {(inputs: Swap_Discomfort_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primero las opciones más livianas. Si es dolor, regístralo en Dolores y limitaciones.`)
};

const pt_pt2_swap_discomfort_lead = /** @type {(inputs: Swap_Discomfort_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opções mais leves primeiro. Se for dor, regista-a em Dores e limitações.`)
};

const fr_fr2_swap_discomfort_lead = /** @type {(inputs: Swap_Discomfort_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options plus légères d'abord. Si c'est une douleur, note-la dans Douleurs et limitations.`)
};

const de_de2_swap_discomfort_lead = /** @type {(inputs: Swap_Discomfort_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leichtere Optionen zuerst. Wenn es Schmerzen sind, trag sie unter Schmerzen und Einschränkungen ein.`)
};

const it_it2_swap_discomfort_lead = /** @type {(inputs: Swap_Discomfort_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prima le opzioni più leggere. Se è dolore, registralo in Dolori e limitazioni.`)
};

/**
* | output |
* | --- |
* | "Lighter options first. If it's pain, log it under Pain and limitations." |
*
* @param {Swap_Discomfort_LeadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_discomfort_lead = /** @type {((inputs?: Swap_Discomfort_LeadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_Discomfort_LeadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_discomfort_lead(inputs)
	if (locale === "es-419") return es_419_swap_discomfort_lead(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_discomfort_lead(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_discomfort_lead(inputs)
	if (locale === "de-DE") return de_de2_swap_discomfort_lead(inputs)
	if (locale === "it-IT") return it_it2_swap_discomfort_lead(inputs)
	return en_us2_swap_discomfort_lead(inputs)
});
export { swap_discomfort_lead as "swap.discomfort_lead" }